import { Loader } from "../components/loader";

export const BlankLoader=()=>{

    return(
        <Loader/>
    );
}